module.exports = __webpack_public_path__ + "media/parallax/separated-leaves-15-886bcc1b.svg";